import React from 'react';
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { EXPIRATION_OPTIONS } from "../../config/expirationOptions";
import styles from './cascadeInfoBanner.module.scss';

export default function CascadeInfoBanner({ sourceLabel, expirationValue }) {
    const { t } = useTranslation();
    const history = useHistory();

    const expirationLabel = (() => {
        if (expirationValue === undefined || expirationValue === null) return null;
        if (expirationValue === 0) return t('NSBonusMode.noExpiration');
        const opt = EXPIRATION_OPTIONS.find(o => o.value === expirationValue);
        return opt ? t(opt.label) : null;
    })();

    return (
        <div className={styles.banner}>
            <span className={styles.icon}>&#9432;</span>
            <div className={styles.text}>
                {sourceLabel && expirationLabel ? (
                    t('NSBonusMode.cascadeBannerWithExpiry', {
                        source: sourceLabel,
                        expiry: expirationLabel,
                    })
                ) : (
                    t('NSBonusMode.cascadeBannerGeneric')
                )}
                {' '}
                <span
                    className={styles.link}
                    onClick={() => history.push('/profile/bonus/mode')}
                >
                    {t('NSBonusMode.goToModeSettings')}
                </span>
            </div>
        </div>
    );
}
